import React, { useContext } from 'react';
import AppContext from '../../AppContext';
import { XMarkIcon } from '@heroicons/react/24/outline'

const Q4BizSidebar = (props) => {
    
  // const [loading, setLoading] = useState(true);
  const { qUrl, qOpen, setQOpen } = useContext(AppContext);

  const toggleRightSide = () => {
    setQOpen(!qOpen)
  }


  return (
    <>
    {!qOpen && <div style={{position: 'absolute', bottom: 10, right: 0}}>
      <button type="button" className="flex justify-end" onClick={() => toggleRightSide()}>
        <img alt="Q for Business" src='/q.svg' style={{marginLeft: 15, marginTop: 5, marginBottom: 20, width: "35%", marginRight: 20}}/>
      </button>
    </div>}

    <div className={qOpen ? "fixed inset-0 flex flex-row-reverse" : "w-0"}>
      <div className="relative flex  max-w-2xl flex-1" style={{marginTop: '60px'}}>
        {qOpen && <div className="absolute right-full flex w-20 justify-center pt-5" >
          <button type="button" className="-m-2.5 p-2.5" onClick={() => toggleRightSide()}>
            <span className="sr-only">Close sidebar</span>
            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>}
        <div className={'flex flex-1 shadow-2xl shadow-gray-900'} >
          <iframe title="qforbusiness" className='w-full' src={qUrl}/>
        </div>
      </div>
    </div>
    </>)
  }

  export default Q4BizSidebar;